import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SwaggerAuthService } from '../../services/auth.service';

/**
 * Swagger Unauthorized Component
 * 
 * Component displaying 403 Unauthorized error page.
 * Shown when user lacks required permissions to access a resource.
 * 
 * Features:
 * - Clean, user-friendly error page
 * - Navigation options
 * - Displays current user information
 * - Option to logout and login with different account
 */
@Component({
    selector: 'swagger-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: true
})
export class SwaggerUnauthorizedComponent implements OnInit {
    private readonly router: Router;
    private readonly authService: SwaggerAuthService;

    companyName: string = '';

    constructor(
        router: Router,
        authService: SwaggerAuthService
    ) {
        this.router = router;
        this.authService = authService;
    }

    ngOnInit(): void {
        this.loadBrandingSettings();
    }

    /**
     * Load branding settings from configuration
     */
    private loadBrandingSettings(): void {
        const settings = this.authService.getSettings();
        if (settings.branding) {
            this.companyName = settings.branding.companyName || settings.branding.platformName || 'Platform';
        }
    }

    /**
     * Get current year for footer
     */
    getCurrentYear(): number {
        return new Date().getFullYear();
    }

    /**
     * Login with different account
     */
    loginWithDifferentAccount(): void {
        this.authService.logout();
    }

    /**
     * Navigate back to previous page
     */
    goBack(): void {
        window.history.back();
    }
}
